<template>
  <div class="new-group-container">
    <div class="form-section">
      <div class="section-header">
        <div class="section-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </div>
        <h2>Új Csoport Létrehozása</h2>
        <p>Adja meg az új csoport részleteit</p>
      </div>
      
      <div class="form-content">
        <form @submit.prevent="addGroup" class="modern-form">
          <div class="form-group">
            <label for="grp_def_name" class="form-label">Csoport általános neve</label>
            <input 
              type="text" 
              id="grp_def_name"
              class="modern-input" 
              v-model="grp_def_name" 
              placeholder="Pl: A csoport" 
              required 
            />
          </div>
          
          <div class="form-group">
            <label for="grp_name" class="form-label">Csoport megjelenő neve</label>
            <input 
              type="text" 
              id="grp_name"
              class="modern-input" 
              v-model="grp_name" 
              placeholder="Pl: Katica csoport" 
              required 
            />
          </div>
          
          <div class="form-group">
            <label class="form-label">Időpontok (több is lehetséges)</label>
            <div v-for="(s, idx) in schedules" :key="idx" class="schedule-row">
              <div class="schedule-inputs">
                <select 
                  class="modern-select select-day" 
                  v-model="s.day" 
                  :required="idx === 0"
                >
                  <option value="">Válasszon napot</option>
                  <option value="1">Hétfő</option>
                  <option value="2">Kedd</option>
                  <option value="3">Szerda</option>
                  <option value="4">Csütörtök</option>
                  <option value="5">Péntek</option>
                  <option value="6">Szombat</option>
                  <option value="7">Vasárnap</option>
                </select>
                <input 
                  type="time" 
                  class="modern-input input-time" 
                  v-model="s.time" 
                  :required="idx === 0" 
                />
                <select 
                  class="modern-select select-freq" 
                  v-model="s.frequency"
                >
                  <option value="weekly">Hetente</option>
                  <option value="biweekly">Kéthetente</option>
                </select>
                <input 
                  v-if="s.frequency === 'biweekly'"
                  type="date" 
                  class="modern-input input-date" 
                  v-model="s.start_date" 
                  :required="s.frequency === 'biweekly'"
                  title="Kezdő dátum"
                />
              </div>
              <button 
                type="button" 
                class="btn-delete" 
                v-if="schedules.length > 1" 
                @click="removeSchedule(idx)" 
                title="Eltávolítás"
              >✕</button>
            </div>
            <button type="button" class="modern-btn modern-btn--secondary modern-btn--small" @click="addSchedule">+ További időpont</button>
          </div>
          
          <div class="form-actions">
            <button type="submit" class="btn-primary" :disabled="loading">
              <svg v-if="loading" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spinning">
                <path d="M21 12a9 9 0 11-6.219-8.56"/>
              </svg>
              <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                <polyline points="17,21 17,13 7,13 7,21"/>
                <polyline points="7,3 7,8 15,8"/>
              </svg>
              {{ loading ? 'Mentés...' : 'Mentés' }}
            </button>
            <button type="button" class="btn-secondary" @click="goNext">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
              Mégse
            </button>
          </div>
          
          <div v-if="message" class="status-message" :class="{'success': success, 'error': !success}">
            <svg v-if="success" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22,4 12,14.01 9,11.01"/>
            </svg>
            <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="15" y1="9" x2="9" y2="15"/>
              <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>
            {{ message }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
      data() {
        return {
          grp_def_name: '',
          grp_name: '',
          schedules: [{ day: '', time: '', frequency: 'weekly', start_date: new Date().toISOString().split('T')[0] }],
          message: '',
          loading: false,
          success: false,
        };
      },
    methods: {
      async addGroup() {
        this.loading = true;
        this.message = '';
        this.success = false;
        
        try {
          const formattedSchedules = this.schedules
            .filter(s => s.day && s.time)
            .map(s => ({
              day: s.day,
              time: s.time,
              frequency: s.frequency || 'weekly',
              start_date: s.frequency === 'biweekly' ? (s.start_date || new Date().toISOString().split('T')[0]) : undefined
            }));

          const response = await fetch(this.$BACKEND_HOST + '/api/newgroup', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: -1,
              def_name: this.grp_def_name,
              name: this.grp_name,
              grp_day: formattedSchedules[0] ? formattedSchedules[0].day : '',
              schedule: JSON.stringify(formattedSchedules)
            })
          });
  
          const data = await response.json();
          this.message = data.message;
          this.success = response.status === 200 && this.message === "done";
          
          if (this.success) {
            setTimeout(() => {
              this.$router.push('/settings/groups');
            }, 1000);
          }
        } catch (error) {
          this.message = 'Nem sikerült lementeni a csoport adatokat';
          this.success = false;
        } finally {
          this.loading = false;
        }
      },
      goNext() {
        // Logic to navigate to the next route
        this.$router.push('/settings/groups'); // Change '/next-route' to your intended route
      },
      addSchedule() {
        this.schedules.push({ day: '', time: '', frequency: 'weekly', start_date: new Date().toISOString().split('T')[0] });
      },
      removeSchedule(idx) {
        this.schedules.splice(idx, 1);
      }
    }
  };
  </script>
  
  <style scoped>
  .new-group-container {
    padding: 2rem;
    max-width: 600px;
    margin: 0 auto;
  }

  .form-section {
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow);
    border: 1px solid var(--color-border);
    overflow: hidden;
  }

  .section-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.5rem 2rem;
    background: var(--color-background-mute);
    border-bottom: 1px solid var(--color-border);
  }

  .section-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
    border-radius: 8px;
    color: white;
    flex-shrink: 0;
  }

  .section-header h2 {
    color: var(--color-heading);
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
  }

  .section-header p {
    color: var(--color-text-muted);
    font-size: 0.95rem;
    margin: 0;
    margin-left: auto;
  }

  .form-content {
    padding: 2rem;
  }

  .modern-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .form-label {
    color: var(--color-heading);
    font-size: 0.95rem;
    font-weight: 500;
    margin: 0;
  }

  .modern-input, .modern-select {
    padding: 0.75rem 1rem;
    border: 2px solid var(--color-border);
    border-radius: 8px;
    background: var(--card-bg);
    color: var(--color-text);
    font-size: 0.95rem;
    transition: all 0.3s ease;
    outline: none;
  }

  .modern-input:focus, .modern-select:focus {
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(var(--primary-blue-rgb), 0.1);
  }

  .modern-input:hover, .modern-select:hover {
    border-color: var(--primary-blue);
  }

  .form-actions {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
    padding-top: 1.5rem;
    border-top: 1px solid var(--color-border);
  }

  .schedule-row {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    margin-bottom: 0.85rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px dashed var(--color-border);
  }

  .schedule-inputs {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    flex: 1;
  }

  .schedule-row .modern-select,
  .schedule-row .modern-input {
    padding: 0.6rem 0.8rem;
  }

  .select-day {
    flex: 1 1 120px;
    min-width: 110px;
  }

  .input-time {
    flex: 0 1 110px;
    min-width: 90px;
  }

  .select-freq {
    flex: 0 1 120px;
    min-width: 100px;
  }

  .input-date {
    flex: 1 1 130px;
    min-width: 110px;
  }

  .btn-delete {
    background: #fee2e2;
    color: #ef4444;
    border: 1px solid #fca5a5;
    border-radius: 8px;
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
    transition: all 0.2s ease;
    flex-shrink: 0;
  }

  .btn-delete:hover {
    background: #ef4444;
    color: #ffffff;
  }

  .btn-primary, .btn-secondary {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    outline: none;
    flex: 1;
    justify-content: center;
  }

  .btn-primary {
    background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
    color: white;
    box-shadow: var(--shadow-sm);
  }

  .btn-primary:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }

  .btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  .btn-secondary {
    background: var(--color-background-mute);
    color: var(--color-text);
    border: 1px solid var(--color-border);
  }

  .btn-secondary:hover {
    background: var(--color-border);
    transform: translateY(-1px);
  }

  .spinning {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .status-message {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    font-size: 0.95rem;
    font-weight: 500;
    margin-top: 1rem;
    border: 1px solid;
  }

  .status-message.success {
    background: rgba(34, 197, 94, 0.1);
    color: #16a34a;
    border-color: rgba(34, 197, 94, 0.2);
  }

  .status-message.error {
    background: rgba(239, 68, 68, 0.1);
    color: #dc2626;
    border-color: rgba(239, 68, 68, 0.2);
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .new-group-container {
      padding: 1rem;
    }

    .section-header {
      padding: 1rem 1.5rem;
    }

    .section-header h2 {
      font-size: 1.25rem;
    }

    .form-content {
      padding: 1.5rem;
    }

    .form-actions {
      flex-direction: column;
    }
  }

  @media (max-width: 576px) {
    .select-day, .input-time, .select-freq, .input-date {
      flex: 1 1 calc(50% - 0.5rem);
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    .new-group-container {
      padding: 0.75rem;
    }

    .section-header {
      padding: 0.75rem 1rem;
    }

    .section-header h2 {
      font-size: 1.125rem;
    }

    .form-content {
      padding: 1rem;
    }

    .btn-primary, .btn-secondary {
      padding: 0.625rem 1.25rem;
      font-size: 0.875rem;
    }
  }
  </style>
